<template>
  <div class="oreder-modal">
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('bill.recharge.title')"
      :visible="visible"
      width="820px"
      :before-close="handleClose"
    >
      <div class="oreder-modal-wrap">
        <el-form label-position="left" label-width="180px">
          <el-form-item :label="$t('bill.recharge.pa')">
            <el-input type="number" v-model="amount" @keyup.native="amount = oninput(amount,2)" min="0.01" max="100000000">
            <template slot="prepend">$</template>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('bill.recharge.pm')">
            <div class="purchase-type">
              <ul>
                <template v-if="canUseCard == 1">
                <li
                  :class="{ 'pay-active': selectedCard === 1}"
                  @click="selectedCard = 1"
                >
                  <el-popover
                    placement="top"
                    trigger="click"
                    v-model="cardPopover"
                  >
                    <div class="payment-list">
                      <div
                        class="payment-item"
                        :class="{
                          'active-payment': payCode == item.cardName,
                        }"
                        v-for="(item, index) in cardList"
                        :key="index"
                        @click="selectCard(item)"
                      >
                        <div class="imgbox" v-if="item.cardName == 'visa'">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-Pay_Visa"></use>
                          </svg>
                        </div>
                        <div
                          class="imgbox"
                          v-if="item.cardName == 'mastercard'"
                        >
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-Pay_Mastercard"></use>
                          </svg>
                        </div>
                        <div class="imgbox" v-if="item.cardName == 'express'">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-Pay_Express"></use>
                          </svg>
                        </div>
                        <div class="imgbox" v-if="item.cardName == 'unionPay'">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-Pay_UnionPay"></use>
                          </svg>
                        </div>
                        <ul class="payment-card">
                          <li>{{ item.cardName }}</li>
                          <li>{{ item.cardNumber }}</li>
                          <li>Expires</li>
                          <li>06/26</li>
                          <li class="orange" v-if="index == 1">Default</li>
                          <li class="orange" v-else>Expiring Soon</li>
                        </ul>
                      </div>
                    </div>
                    <div slot="reference">
                      <div class="iconbox">
                        <p v-if="payCode == 'visa' || selectedCard == 0 || (cardId == 0 && selectedCard == 1)">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-Pay_Visa"></use>
                          </svg>
                        </p>
                        <p v-if="payCode == 'mastercard' || selectedCard == 0 || (cardId == 0 && selectedCard == 1)">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-Pay_Mastercard"></use>
                          </svg>
                        </p>
                        <p v-if="payCode == 'express' || selectedCard == 0 || (cardId == 0 && selectedCard == 1)">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-Pay_Express"></use>
                          </svg>
                        </p>
                        <p v-if="payCode == 'unionPay' || selectedCard == 0 || (cardId == 0 && selectedCard == 1)">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-Pay_UnionPay"></use>
                          </svg>
                        </p>
                      </div>
                      <p v-if="selectedCard == 1 && payCode != ''">{{ upperCase }}</p>
                      <p v-else>Credit Card</p>
                    </div>
                  </el-popover>
                </li>
                </template>
                <template   v-for="payment in payments">
                  <li
                    :class="{ 'pay-active': payCode === payment.pay_code }"
                    @click="selectPayment(payment)"
                  >
                    <div class="iconbox">
                      <p>
                        <svg class="icon" aria-hidden="true">
                          <use :xlink:href="payment.icon"></use>
                        </svg>
                      </p>
                    </div>
                    <p>{{ payment.pay_name }}</p>
                  </li>
                </template>
              </ul>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{$t('bill.recharge.cancel')}}</el-button>
        <el-button type="primary" @click="placeOrder" :disabled="disabled">{{$t('bill.recharge.pay')}}</el-button>
      </div>
    </el-dialog>
    <!-- 支付状态弹窗 -->
    <Paying ref="paymodal" @close="payClose"/>
  </div>
</template>
<script>
import Paying from "@/components/payDialog/Paying";
export default {
  inject:['reload'],
  data() {
    return {
      selectedCard: 1,
      payCode: '',
      cardId: '',
      amount: '',
      visible: false,
      cardList: [
        {
          cardId: 1,
          cardName: "visa",
          cardNumber: "532 748 326 7238 842",
        },
        {
          cardId: 2,
          cardName: "mastercard",
          cardNumber: "532 748 326 7238 842",
        },
        {
          cardId: 3,
          cardName: "express",
          cardNumber: "532 748 326 7238 842",
        },
        {
          cardId: 4,
          cardName: "unionPay",
          cardNumber: "532 748 326 7238 842",
        },
      ],
      cardPopover: false, //卡列表选择
      orderSn: '',
      disabled: true,
      payments:  [],//交易渠道列表
      canUseBalance: 0,
      canUseCard: 0,
    };
  },
  computed: {
    upperCase: function () {
      if(this.payCode != '') {
        return this.payCode.substring(0, 1).toUpperCase() + this.payCode.substring(1);
      } else {
        return this.payCode;
      }
    }
  },
  watch: {
    visible: {
      handler(n, o) {
        this.visible = n;
      },
    },
    amount: {
      handler (n, o) {
        let reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/;
        if (reg.test(n) && n <= 100000000) {
            this.disabled = false;
          } else {
            this.disabled = true;
          }
      },
      immediate: true,
      deep: true,
    },
  },
  components: {
    Paying,
  },
  props: {},
  methods: {
    async getPayments() {
      let {data: {code, message, data}} = await this.$http.get('/general/payments/lists', {type: 'Charge'})
      if (code !== 0) {
        this.$message.error(message)
        return false
      }
      this.payments = data.channel;
      this.canUseBalance = data.useBalance;
      this.canUseCard = data.useCard;
      if(this.canUseCard == 0) {
        this.selectPayment(data.defaultPayment);
      }
    },
    payClose(){
      this.$emit('getMoneyList');
      window.clearInterval(this.refreshIntervalId);
      this.visible = false;
    },

    oninput(val,limit = 0){
      val = val.replace(/[^\d.]/g, ""); //保留数字
      val = val.replace(/^00/, "0."); //开头不能有两个0
      val = val.replace(/^\./g, "0."); //开头为小数点转换为0.
      val = val.replace(/\.{2,}/g, "."); //两个以上的小数点转换成一个
      val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", "."); //只保留一个小数点
      /^0\d+/.test(val) ? val = val.slice(1) : ''; //两位以上数字开头不能为0
      const str = '^(\\d+)\\.(\\d{' + limit + '}).*$'
      const reg = new RegExp(str)
      if (limit === 0) {
        // 不需要小数点
        val= val.replace(reg, '$1')
      } else {
        // 通过正则保留小数点后指定的位数
        val= val.replace(reg, '$1.$2')
      }
      return val;
    },
    handleClose() {
      this.visible = false;
      window.clearInterval(this.refreshIntervalId);
      this.$emit('getMoneyList');
    },
    showChange() {
      this.visible = !this.visible;
    },
    selectPayment(payment) {
      this.payCode = payment.pay_code;
      this.selectedCard = 0;
      this.cardId = 0;
      this.callPayApiMethod = payment.submit_method;
    },
    selectCard(e) {
      this.selectedCard = 1;
      this.payCode = e.cardName;
      this.cardId = e.id;
      this.cardPopover = false;
      this.callPayApiMethod = e.callPayApiMethod;
    },
    // 下单
    async placeOrder() {
      this.requestPending = true
      let {data: {code, message, data}} = await this.$http.post('/user/recharge', {
        pay_money: this.amount, pay_code: this.payCode
      })
      if (code !== 0) {
        this.$message.error(message)
        this.requestPending = false
        return false
      }

      this.orderSn = data.sn;
      if (this.callPayApiMethod == 'page') {
        this.$nextTick(() => {
          this.$refs.paymodal.orderType = 'recharge';
          this.$refs.paymodal.orderSn = this.orderSn;
          this.$refs.paymodal.showChange();
          window.open(process.env.YISU_API_URL+'/pay/index?sn='+this.orderSn+'&pay_code='+this.payCode+'&order_code=Charge&platform=pc');
        });
        this.refreshIntervalId = window.setInterval(() => {
          this.checkOrderStatus()
          this.timer = this.timer - 2;
        }, 2000);
      } else {
        this.pay(this.orderSn);
      }
    },
    async checkOrderStatus() {
      let {
        data: {code, message, data},
      } = await this.$http.post("/pay/checkChargeOrderStatus", {
        sn: this.orderSn,
      });
      if(code == 0) {
        this.$refs.paymodal.paystatus = 'success';
        window.clearInterval(this.refreshIntervalId);
      } else {
        if(this.timer <= 0) {
          this.$refs.paymodal.paystatus = 'error';
          window.clearInterval(this.refreshIntervalId);
        }
        return false
      }
    }
  },
};
</script>

<style scoped lang="scss">
.purchase-type {
  display: flex;
  align-items: center;
  padding-bottom: 16px;

  p {
    color: #0f1e33;
    font-size: 14px;
    line-height: 22px;
    width: 150px;
    opacity: 0.8;
    flex-shrink: 0;
  }

  ul {
    flex: 1;
    display: grid;
    grid-gap: 20px;
    grid-template-columns: repeat(3, 160px);

    li {
      width: 160px;
      height: 90px;
      border: 1px solid #dbe1e8;
      cursor: pointer;

      .iconbox {
        display: flex;
        margin: 0 auto 12px;
        padding: 24px 20px 0;
        p {
          flex: 1;
          height: 16px;
          .icon {
            height: 16px;
            width: 100%;
            font-size: 30px;
          }
        }
      }
      .payicon-list {
        padding: 0 24px;
      }

      p {
        color: #0f1e33;
        font-size: 14px;
        text-align: center;
        font-weight: bold;
      }

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        box-shadow: 0px 2px 6px 0px rgba(31, 37, 51, 0.16);
      }

      &.pay-active {
        border-color: #3377ff;
        box-shadow: 0px 2px 6px 0px rgba(31, 37, 51, 0.16);
      }
    }
  }
}
.tips {
  font-size: 12px;
  margin-bottom: 24px;
}
.payment-list {
  max-height: 400px;
  overflow: auto;
  .payment-item {
    font-size: 16px;
    border: 1px solid #dbe1e8;
    padding: 10px 24px;
    margin-bottom: 12px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    cursor: pointer;

    .imgbox {
      width: 60px;
      height: 30px;
      text-align: center;
      margin-right: 20px;
      .icon {
        display: inline-block;
        width: 60px;
        height: 30px;
      }
    }

    .payment-card {
      height: 50px;
      display: flex;
      align-items: center;
      li {
        color: #0f1e33;
        font-size: 14px;
        margin-right: 20px;
        &:first-child {
          width: 90px;
        }
      }
      .orange {
        color: #f7ba2a;
      }
    }
  }
  .active-payment {
    border-color: #3377ff;
    box-shadow: 0px 2px 6px 0px rgba(31, 37, 51, 0.16);
  }
  .payment-item:hover {
    box-shadow: 0px 2px 6px 0px rgba(31, 37, 51, 0.16);
  }
}
.addBtn {
  margin-left: 150px;
  margin-bottom: 24px;
}
.password-wrap {
  padding-left: 150px;
  position: relative;
  > p {
    position: absolute;
    left: 0;
    line-height: 40px;
  }
}
.view-icon {
  width: 16px;
  height: 16px;
  margin-top: 12px;
  font-size: 16px;
  cursor: pointer;
  padding-right: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/user/Recharge.vue